import { faCalculator } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a calculator icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/calculator?s=solid
 */
export const CalculatorIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCalculator} {...props} />;
};
